import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { showError } from "lib/notification";
import { useParams } from "react-router";
import LoginView from "components/layout/login-view";
import {
  userDoGetListInvitation,
  userdoGetListInvitationDetails,
} from "services/user/list-invitation";
import Signicat from "components/signicat";
import { useLocale } from "stores/hooks/locale";
import { userDoPostInvitationSignicatSessions } from "services/signicat";
import { changeLocale } from "stores/actions/locale";
import { LocaleString } from "models/locale";
import { parse } from "lib/locale";
import Line from "components/layout/line";
import { useTranslate } from "stores/hooks/translation";

interface UserInvitationViewProps {}

const UserInvitationView: FunctionComponent<UserInvitationViewProps> = () => {
  const locale = useLocale();
  const translate = useTranslate();
  const [transition, toggleTransition] = useState(false);
  const [linkStatus, toggleLinkStatus] = useState(false);
  const [linkInvalid, toggleLinkInvalid] = useState(false);
  const [name, toggleName] = useState<LocaleString | undefined>(undefined);
  const { invitationUuid } = useParams();

  useEffect(() => {
    if (!invitationUuid) {
      return;
    }

    const check = async () => {
      try {
        await userDoGetListInvitation(invitationUuid);
        const { name, locale } =
          await userdoGetListInvitationDetails(invitationUuid);

        // store
        toggleLinkStatus(true);
        toggleLinkInvalid(false);
        toggleName(name);
        changeLocale(locale);
      } catch (err) {
        toggleLinkStatus(true);
        toggleLinkInvalid(true);
      }
    };
    check();
  }, [invitationUuid]);

  const beginSignicat = async () => {
    if (!invitationUuid) {
      return;
    }

    try {
      const response = await userDoPostInvitationSignicatSessions(
        invitationUuid,
        locale,
      );
      const { authenticationUrl } = response;

      // start animation
      toggleTransition(true);

      setTimeout(() => (window.location.href = authenticationUrl), 500);
    } catch (err) {
      // login failed, show error
      showError("Login failed!");
    }
  };

  if (!linkStatus) {
    return null;
  }

  if (linkInvalid) {
    return (
      <LoginView
        title={translate("login_link_expired_title")}
        transition={transition}
      >
        <p>{translate("login_link_expired_text")}</p>
      </LoginView>
    );
  }

  const listName = parse(name, locale);
  return (
    <LoginView title={listName} transition={transition}>
      <Fragment>
        <p>{translate("login_link_p1")}</p>
        <p>{translate("login_link_p2")}</p>
      </Fragment>
      <Line text={translate("login_begin_auth")} />
      <Signicat onClick={beginSignicat} />
    </LoginView>
  );
};

export default UserInvitationView;
